import { extendTheme } from '@chakra-ui/react';

import { components } from './components';
import { colors } from './colors';
import { fonts } from './fonts';
import { fontSizes } from './fontSizes';
import { lineHeights } from './lineHeights';
import { styles } from './styles';

export const theme = extendTheme({
  components,
  colors,
  fonts,
  fontSizes,
  lineHeights,
  styles
});
